/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StartExecutionResponse } from './StartExecutionResponse';
import {
    StartExecutionResponseFromJSON,
    StartExecutionResponseFromJSONTyped,
    StartExecutionResponseToJSON,
    StartExecutionResponseToJSONTyped,
} from './StartExecutionResponse';

/**
 * 
 * @export
 * @interface StartExecution202Response
 */
export interface StartExecution202Response {
    /**
     * 
     * @type {StartExecutionResponse}
     * @memberof StartExecution202Response
     */
    data?: StartExecutionResponse;
}

/**
 * Check if a given object implements the StartExecution202Response interface.
 */
export function instanceOfStartExecution202Response(value: object): value is StartExecution202Response {
    return true;
}

export function StartExecution202ResponseFromJSON(json: any): StartExecution202Response {
    return StartExecution202ResponseFromJSONTyped(json, false);
}

export function StartExecution202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecution202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : StartExecutionResponseFromJSON(json['data']),
    };
}

export function StartExecution202ResponseToJSON(json: any): StartExecution202Response {
    return StartExecution202ResponseToJSONTyped(json, false);
}

export function StartExecution202ResponseToJSONTyped(value?: StartExecution202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StartExecutionResponseToJSON(value['data']),
    };
}

